export function allHotelProductsSchema(hotelId: number, pinnedResult: boolean) {
  return [
    {
      messageContent: {
        numOfProducts: 1,
        hotelProducts: [
          {
            pinned: {
              pinnedResult
            },
            productType: 'HOTELS',
            productId: hotelId
          }
        ]
      },
      schemaName: 'allHotelProducts'
    }
  ];
}
